import Trash2Icon from './icons/Trash2Icon';

interface DeleteChecklistModalProps {
  checklistName: string;
  onDelete: () => void;
  onClose: () => void;
}

export function DeleteChecklistModal({
  checklistName,
  onDelete,
  onClose,
}: DeleteChecklistModalProps) {
  return (
    <div className="bg-gray-800 rounded-lg p-6 max-w-md w-full">
      <div className="flex items-center gap-3 mb-4">
        <span className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center">
          <span className="w-5 h-5">
            <Trash2Icon />
          </span>
        </span>
        <h3 className="text-xl font-bold text-white">Delete Checklist</h3>
      </div>
      <p className="text-gray-300 mb-6">
        Are you sure you want to delete
        <span className="text-white font-semibold">&quot;{checklistName}&quot;</span>? This action
        cannot be undone.
      </p>
      <div className="flex justify-end gap-3">
        <button
          onClick={onClose}
          className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg transition-colors"
        >
          Cancel
        </button>
        <button
          onClick={onDelete}
          className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg transition-colors"
        >
          Delete
        </button>
      </div>
    </div>
  );
}
